//duration in seconds
export const PDF_PER_PAGE_DURATION = 7;
